import React from 'react';
import SpotifyIcon from '../../images/external-links-icons/spotify.svg';
import ApplePodcastIcon from '../../images/external-links-icons/apple_podcast.svg';
import GooglePodCastIcon from '../../images/external-links-icons/google_podcast.svg';
import YoutubeIcon from '../../images/external-links-icons/youtube.svg';
import AmazonMusic from '../../images/external-links-icons/amazon.svg';

const twoLinks = [
  {
    icon: SpotifyIcon,
    link: 'https://open.spotify.com/show/2Cy2doz5mav5KycXrdl1Hn?si=9190bf946fad413c',
    alt: 'Spotify Icon',
  },

  {
    icon: YoutubeIcon,
    link: 'https://www.youtube.com/watch?v=nljU9_vv3_Y&list=PLAortNXplLTiicS6j_TUXN9O-5B4zU3Zt',
    alt: 'Youtube Icon',
  },
];

const remainingThreeLinks = [
  {
    icon: ApplePodcastIcon,
    link: 'https://podcasts.apple.com/us/podcast/the-lineage-journey-podcast/id1606476578?uo=4',
    alt: 'Apple Podcast Icon',
  },
  {
    icon: AmazonMusic,
    link: 'https://music.amazon.com/podcasts/61a81cd5-2ce3-422a-bca5-d51538345cc8',
    alt: 'Amazon Podcast Icon',
  },
  {
    icon: GooglePodCastIcon,
    link: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy50cmFuc2lzdG9yLmZtL3RoZS1saW5lYWdlLXBvZGNhc3Q=',
    alt: 'Google Podcast Icon',
  },
];

const links = [...twoLinks, ...remainingThreeLinks];

const PodcastExternalLinks = () => {
  return (
    <div className="wrapper wrapper-lg pd-x-md podcasts-external-links">
      <div className="links-items items">
        {links.map((item, index) => {
          return (
            <a key={index} href={item.link} target="_blank">
              <img src={item.icon} alt={item.alt} />
            </a>
          );
        })}
      </div>

      <div className="links-items items-sm">
        {twoLinks.map((item, index) => {
          return (
            <a key={index} href={item.link} target="_blank">
              <img src={item.icon} alt={item.alt} />
            </a>
          );
        })}
      </div>

      <div className="links-items items-sm">
        {remainingThreeLinks.map((item, index) => {
          return (
            <a key={index} href={item.link} target="_blank" className="pt-64">
              <img src={item.icon} alt={item.alt} />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default PodcastExternalLinks;
